import React from 'react';

import uicon from '@assets/images/university-logo.png';

import { useWindowDimensions } from '@hooks';

import { EScreenTypes, EThemesEnum } from '@enum';

import { UIconContainer, UIconImg } from './UniversityIcon.styled';

import { UniversityIconProps } from './UniversityIcon.types';

export const UniversityIcon = ({ themeType }: UniversityIconProps) => {
  const { type } = useWindowDimensions();

  return (
    <UIconContainer>
      <UIconImg
        width={type === EScreenTypes.mobile ? 150 : 300}
        src={uicon}
        alt="university-icon"
        reversed={themeType === EThemesEnum.dark}
      />
    </UIconContainer>
  );
};
